module.exports = __webpack_public_path__ + "assets/img/Group 5@1,5x.908cd33c.svg";